import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import CategoricalTypeOptionsForm from "./CategoricalTypeOptionsForm";

const CategoricalTypeOptionsModal = ({
  open,
  onOpenChange,
  fieldOptions,
  onSave,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Categorical Type Options</DialogTitle>
      </DialogHeader>
      {open && (
        <CategoricalTypeOptionsForm
          fieldOptions={fieldOptions}
          onSuccess={data => {
            onSave(data);
            onOpenChange(false);
          }}
          onCancel={() => onOpenChange(false)}
        />
      )}
    </DialogContent>
  </Dialog>
);

export default CategoricalTypeOptionsModal;
